import normalize from 'json-api-normalizer';
import Page from './page.js';
import Survey from './survey.js';
import SurveyLink from './survey_link.js';
import { mapDebugActions } from '@/lib/debug.js';


export default class Task {
	static from (jsonapi) {
		let key = 'tasks'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Task.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Task.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make (jsonapi, normalizedJSONapi, noRelationships=0, lock=0) {
		const { id, attributes } = jsonapi;
		let relationships = {}

		relationships['item'] = null
		if (jsonapi.relationships && attributes.itemId != null && noRelationships == 0) {
			switch (attributes.itemType) {
				case 'content_task':
					if (normalizedJSONapi['pages'] && normalizedJSONapi['pages'][attributes.itemId]) {
						relationships['item'] = Page.make(normalizedJSONapi['pages'][attributes.itemId], normalizedJSONapi)
					} else if (normalizedJSONapi['slideshows'] && normalizedJSONapi['slideshows'][attributes.itemId]) {
						relationships['item'] = Page.make(normalizedJSONapi['slideshows'][attributes.itemId], normalizedJSONapi)
					} else if (normalizedJSONapi['collections'] && normalizedJSONapi['collections'][attributes.itemId]) {
						relationships['item'] = Page.make(normalizedJSONapi['collections'][attributes.itemId], normalizedJSONapi)
					} else if (normalizedJSONapi['slides'] && normalizedJSONapi['slides'][attributes.itemId]) {
						relationships['item'] = Page.make(normalizedJSONapi['slides'][attributes.itemId], normalizedJSONapi)
					}
					break;

				case 'survey_task':
					if (normalizedJSONapi['surveys'] && normalizedJSONapi['surveys'][attributes.itemId]) {
						relationships['item'] = Survey.make(normalizedJSONapi['surveys'][attributes.itemId], normalizedJSONapi)
					}
					break;

				case 'task_lock':
					if (normalizedJSONapi['tasks'] && normalizedJSONapi['tasks'][attributes.itemId]) {
						relationships['item'] = Task.make(normalizedJSONapi['tasks'][attributes.itemId], normalizedJSONapi, 0, 1)
					}
					break;

				case 'survey_lock':
					if (normalizedJSONapi['surveyLinks'] && normalizedJSONapi['surveyLinks'][attributes.itemId]) {
						relationships['item'] = SurveyLink.make(normalizedJSONapi['surveyLinks'][attributes.itemId], normalizedJSONapi)
					}
					break;
			}
		}

		relationships['locks'] = {}
		if (jsonapi.relationships && jsonapi.relationships['tasks'] && lock == 0 && noRelationships == 0) {
			jsonapi.relationships['tasks'].data.forEach( function (rel) {
				if (normalizedJSONapi[rel.type][rel.id]) {
					relationships['locks'][rel.id] = Task.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);
				}
			});
		}

		return new Task ( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, position, name, stageId, itemId, itemType, item, parentId, locks, expiresIn, createdAt, updatedAt, complete, completePercent, unlocked, displayTitle }) {
		this.id					= id ? id : -1;
		this.stage_id			= stageId ? stageId : -1;
		this.position			= position ? position : 0;
		this.name				= name ? name : '';
		this.item_id			= itemId ? itemId : null;
		this.item_type			= itemType ? itemType : null;
		this.item				= item ? item : null;
		this.parent_id			= parentId ? parentId : null;
		this.locks				= locks ? locks : {};
		this.expires_in			= expiresIn ? expiresIn : 0;
		this.created_at			= createdAt ? createdAt : null;
		this.updated_at			= updatedAt ? updatedAt : null;
		this.complete           = complete ? complete : false;
		this.complete_percent	= completePercent ? completePercent : 0;
		this.unlocked			= unlocked ? unlocked : false;
		this.display_title = displayTitle? displayTitle:null;
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);
		delete attributes.id;
		delete attributes.item;

		return {data: {type: "tasks", id: this.id, attributes: attributes}};
	}
}
